const getSavedRoiGateFormData = require("./getSavedRoiGateFormData");
const convertCalculatorDataToMarketoCalculatorData = require("./convertCalculatorDataToMarketoCalculatorData");
const loadMarketoForm = require("../marketo/loadMarketoForm");
const copyFormDataIntoMarketoForm = require("../marketo/copyFormDataIntoMarketoForm");
const submitMarketoForm = require("../marketo/submitMarketoForm");
const saveRoiGateFormReturningUserData = require("./saveRoiGateFormReturningUserData");
const logRoiGateFormSubmissionSuccess = require("./logRoiGateFormSubmissionSuccess");
const logRoiGateFormSubmissionFailure = require("./logRoiGateFormSubmissionFailure");
const removeMarketoFormEmbed = require("../marketo/removeMarketoFormEmbed");

/**
 * @param calculatorData {CalculatorData}
 * @return {Promise<void>}
 */
module.exports = async function submitRoiCalculator1233Form(calculatorData) {
    const marketoId = "1233";

    const roiGateFormData = getSavedRoiGateFormData();
    roiGateFormData["formid"] = marketoId;
    roiGateFormData["formVid"] = marketoId;
    const marketoCalculatorData = convertCalculatorDataToMarketoCalculatorData(calculatorData);

    let marketoFormContainer;
    try {
        const marketoFormElements = await loadMarketoForm(marketoId);

        const marketoForm = marketoFormElements.marketoForm;
        marketoFormContainer = marketoFormElements.marketoFormContainer;

        copyFormDataIntoMarketoForm(marketoForm, roiGateFormData);
        copyFormDataIntoMarketoForm(marketoForm, marketoCalculatorData);

        await submitMarketoForm(marketoForm);

        saveRoiGateFormReturningUserData(roiGateFormData);

        await logRoiGateFormSubmissionSuccess(roiGateFormData);
    } catch (e) {
        void logRoiGateFormSubmissionFailure(roiGateFormData);

        alert("Cannot submit form");
    } finally {
        if (marketoFormContainer) {
            removeMarketoFormEmbed(marketoFormContainer);
        }
    }
}
